// Accounting Income Types Vuex

import state from './incomeTypeStates.js'
import * as getters from './incomeTypeGetters.js'
import * as mutations from './incomeTypeMutations.js'
import * as actions from './incomeTypeActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
